/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getLog.defs'
export { main as default } from './getLog.defs'
